import React, {Component} from 'react';
import { Link } from 'components/ReactRouterDomLocalized';
import MasonryLayout from 'react-masonry-layout';

import DisableMyGuestbook from 'components/guestbook/DisableMyGuestbook';
import GuestbookItem from 'components/guestbook/GuestbookItem';

import {t} from 'l10n'

import paths from 'paths';

import 'sass/member/MemberGuestbookBlock.scss';
import isMobile from "ismobilejs";

class MemberGuestbookBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        let {guestbookMessages, match} = this.props,
            {list, totalCount} = guestbookMessages;

        const sizes = [
            { mq: '320px', columns: 1, gutter: 10 },
            { mq: '360px', columns: 1, gutter: 10 },
            { mq: '680px', columns: 2, gutter: 10 },
            { mq: '720px', columns: 2, gutter: 20 },
            { mq: '1060px', columns: 3, gutter: 20 },
            { mq: '1420px', columns: 4, gutter: 20 },
            { mq: '1560px', columns: 4, gutter: 20 },
            { mq: '1601px', columns: 4, gutter: 20 },
        ];

        return (
            <aside className="guestbook-member">
                <div className="content">
                    <div className="heading">
                        <h2>{t('My guestbook')} <em>{totalCount}</em></h2>
                        <div>
                            <DisableMyGuestbook/>
                            {list.length && !isMobile.any ? <Link to={paths.memberGuestbook.path} className="list-items">{t('All of my guestbook')}</Link> : null}
                        </div>
                    </div>
                    <div className="list-guestbook-main">
                        <MasonryLayout
                            sizes={sizes}
                            id="member-guestbook"
                            infiniteScroll={() => {}}
                            ref={(ref) => this.masonryLayout = ref}
                        >
                            {list.map((item) => <GuestbookItem key={item.id} guestbookMessage={item} deleteButton/>)}
                        </MasonryLayout>
                        {/* {list.map((item, index) => <GuestbookItem guestbookMessage={item} deleteButton key={index}/>)} */}
                    </div>
                    {(list.length && isMobile.any) ? <Link to={paths.memberGuestbook.path} className="get-all-guestbook">{t('All of my guestbook')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

export default MemberGuestbookBlock;


// WEBPACK FOOTER //
// ./src/components/member/MemberGuestbookBlock.js